/**
 * 搜索列表页插件
 */
import instance from "../../interceptor" //axios封装
class SearchListPage {
  constructor(vue) {
    this.context = vue
    this.request_prefix = this.context.request_prefix
    this.appId = this.context.$store.state.states.getDataPageIds.appId
    this.homePageId = this.context.$store.state.states.getDataPageIds.homePageId
    this.listPageId = this.context.$store.state.states.getDataPageIds.listPageId
    this.keyWord = this.context.$store.state.states.getDataPageIds.searchKey
    this.containerId = 0
    this.simpleSearchInputId = null // 搜索输入框id
    this.simpleSearchButtonId = null // 搜索按钮id
    this.subPage = JSON.parse(window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.request_prefix))
    this.showSearchComponent = this.subPage.listPageSetting.showSearchComponent
  }
  async init() {
    sessionStorage.removeItem("hasSearchComponent")
    // 获取搜索列表页数据
    this.initSimpleSearchWatcher()
  }
  async getKeyWord() {
    let url = window.location.href
    let subIndex = url.split("/").indexOf("sub")
    let uuid = ""
    // 线上和10环境不同 新传的参数需要通过接口获取 输入框值存在最后一位
    if (subIndex != -1) {
      uuid = url.split("/")[subIndex + 1]
      let getQuery = await instance.get({
        url: `sub-page-link/get/${uuid}`
      })
      let urlData = getQuery && getQuery.data?.data?.url?.split("/")
      return urlData ? urlData[urlData.length - 1] : ""
    }
  }
  // 找到简单搜索组件
  findSearchComponent() {
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options?.pluginName?.includes("ListPageSearchComponentPlugin")
    })[0]
  }
  // 找到列表页中的组件
  findComponent(type) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.shape === type && !rect.options?.pluginName?.includes("ListPageSearchComponentPlugin")
    })[0]
  }
  initSimpleSearchWatcher() {
    // 获取展示列表的id
    const emptyLayoutComponent_rect_id = this.findComponent("emptyLayoutComponent")?.rect_id
    const simpleSearchComponet = this.findSearchComponent()
    if (!simpleSearchComponet) return
    sessionStorage.setItem("hasSearchComponent", "1")
    const uid = simpleSearchComponet.options?.rows[0]?.cols[0]?.uid
    const idPrefix = `container_id_${this.containerId}-rect_id_${simpleSearchComponet.rect_id}-uid_${uid}-elementInLayoutId_`
    this.simpleSearchInputId =
      idPrefix + simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions[0]?.elementInLayoutId
    this.simpleSearchButtonId =
      idPrefix + simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions[1]?.elementInLayoutId
    // 监听搜索输入框值变化 并赋值
    const elementInLayoutId = simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions[0]?.elementInLayoutId
    let param = {
      option_name: "inputValue",
      option_val: this.keyWord,
      container_id: this.containerId,
      rect_id: simpleSearchComponet.rect_id,
      elementInLayoutId: elementInLayoutId,
      uid: uid
    }
    this.context.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
    setTimeout(() => {
      // 刚进来时初始化数据
      const searchInputValue = simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions[0]?.inputValue
      this.context.$eventBus.$emit(`update-layout-data-eventBus-${this.containerId}-${emptyLayoutComponent_rect_id}`, {
        searchKey: searchInputValue
      })
      const searchButton = document.getElementsByClassName(this.simpleSearchButtonId)[0]
      if (searchButton) {
        this.clickSearchButtonBind = this.clickSearchButton.bind(this)
        searchButton.addEventListener("click", this.clickSearchButtonBind, true)
      }
      const ids = {
        container_id: this.containerId,
        rect_id: simpleSearchComponet.rect_id
      }
      if (this.showSearchComponent) {
        this.context.$changeOptionsEV(100, "opacity", false, null, { ...ids }, true)
      } else {
        this.context.$changeOptionsEV(0, "opacity", false, null, { ...ids }, true)
      }
    }, 200)
  }
  handleSearchListPageSetting(type) {
    const subPage = JSON.parse(
      window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.context.request_prefix)
    )
    const value = subPage.listPageSetting[type]
    if (type === "showSearchComponent") {
      const rectAttr = this.findSearchComponent()
      if (!rectAttr) return
      const ids = {
        container_id: this.containerId,
        rect_id: rectAttr.rect_id
      }
      this.context.$changeOptionsEV(value ? 100 : 0, "opacity", false, null, { ...ids })
    }
  }
  clickSearchButton() {
    const emptyLayoutComponent_rect_id = this.findComponent("emptyLayoutComponent")?.rect_id
    // 获取当前搜索的值
    const searchInputValue = this.findSearchComponent()?.options?.rows[0]?.cols[0].elementOptions[0]?.inputValue
    // 通知自由布局更新数据
    this.context.$eventBus.$emit(`update-layout-data-eventBus-${this.containerId}-${emptyLayoutComponent_rect_id}`, {
      searchKey: searchInputValue
    })
  }
  removeEventTrigger() {
    const searchButton = document.getElementsByClassName(this.simpleSearchButtonId)[0]
    if (searchButton) {
      searchButton.removeEventListener("click", this.clickSearchButtonBind, true)
    }
  }
}

export default {
  methods: {
    searchListPagePlugin() {
      const searchListPage = new SearchListPage(this)
      this.searchListPage = searchListPage
      searchListPage.init()
    },
    handleSearchListPageSetting(type) {
      this.searchListPage?.handleSearchListPageSetting(type)
    }
  },
  beforeDestroy() {
    this.searchListPage?.removeEventTrigger()
  }
}
